import { getCookie } from './utils'

export default function authHeader(authValue = 1, contentType = 'json') {
  // return authorization header with jwt token
  //config.accesstoken => This is the client access token used for unauthorized api calls
  //getCookie('uaccess_token') => This is the user token used for all authorized api calls
  let accessToken = ''
  if (authValue === 1) {
    accessToken = getCookie('uaccess_token')
  } else if (authValue === 0) {
    accessToken = getCookie('saccess_token')
  }

  const headerObj = {
    ...getContentType(contentType),
    Accept: '*/*',
    ...(authValue >= 0 ? { Authorization: `Bearer ${accessToken}` } : {})
  }
  return headerObj
}

const getContentType = (type) => {
  if (type === 'json') {
    return { 'Content-Type': 'application/json; charset="utf-8"' }
  }
  return {}
}
